function usePosApi() {
    const pos = window.shopify.pos;

    async function endpoint(path) {
        const location = await pos.location();
        return `/api/pos/${location.id}/${path}`;
    }

    async function request(path, options) {
        const location = await pos.location();
        const response = await fetch(await endpoint(path), {
            ...options,
            headers: {
                ...(options?.headers ?? {}),
                Accept: 'application/json',
                'X-Shopify-Pos-Location': location.id,
            },
        });

        return {
            response: response,
            ok: response.ok,
            data: response.bodyUsed ? null : await response.json(),
        };
    }

    request.post = function post(path, body = {}) {
        return request(path, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
    };

    const planetApi = {
        getOrCreatePreIssuedForm: async (orders, source, fiscalNumber = '', invoiceNumbers = '') => {
            const response = await request.post('pre-issued-forms', {
                orders: orders,
                source: source,
                fiscal_number: fiscalNumber,
                invoice_numbers: invoiceNumbers,
            });

            return response;
        },

        completePreIssuedForm: async ({ preIssuedFormId, barcode, refundMethod, refundAmount, pdf }) => {
            if ('number' === typeof refundAmount) {
                refundAmount = refundAmount.toFixed(2);
            }

            const { data } = await request.post(`pre-issued-forms/${preIssuedFormId}/complete`, {
                barcode: barcode,
                refund_method: refundMethod,
                refund_amount: refundAmount,
                pdf: pdf,
            });

            return data;
        },

        voidPreIssuedForm: async (preIssuedFormId) => {
            const response = await request.post(`pre-issued-forms/${preIssuedFormId}/void`);

            return response;
        },
    };

    return {
        endpoint,
        request,
        planetApi,
    };
}

export default usePosApi;
